import { ExportCSVReport } from '@utils/createCSVReportFile';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { catalogRemoveConstructionTypeMutation } from '../catalogConstructionTypesQueries';

const requestId = 'removeConstructionType';

export const useRemoveConstructionType = (catalogConstructionTypeId: number, onRemoveSuccess: () => void) => {
    const dispatch = useDispatch();
    const [isSubmitted, setIsSubmitted] = useState(false);

    const [catalogRemoveConstructionTypeReset] = useResetStoreData({ requestId });

    const onSuccessLocal = () => {
        setIsSubmitted(false);
        catalogRemoveConstructionTypeReset(undefined);

        onRemoveSuccess();
    };

    const [removeData, removeStatus, removeError, removeRequest] = useRequest({
        requestId,
        query: catalogRemoveConstructionTypeMutation,
        withEffect: false,
        dependenciesUpdater: ({ payload }) => {
            if (payload?.catalogRemoveConstructionType?.result) {
                onSuccessLocal();
            }
        },
    });

    const catalogRemoveConstructionTypeRequest = () => {
        setIsSubmitted(true);
        dispatch(removeRequest({ catalogConstructionTypeId }));
    };

    const handleCloseModalError = () => {
        setIsSubmitted(false);
        catalogRemoveConstructionTypeReset(undefined);
    };

    const handleCreateReport = () => {
        ExportCSVReport(removeData?.catalogRemoveConstructionType?.validation);
    };

    useEffect(() => {
        catalogRemoveConstructionTypeReset(undefined);
    }, [catalogRemoveConstructionTypeReset]);

    return {
        catalogRemoveConstructionTypeRequest,
        catalogRemoveConstructionTypeData: removeData,
        catalogRemoveConstructionTypeStatus: removeStatus,
        catalogRemoveConstructionTypeError: removeError,
        isSubmitted,
        handleCloseModalError,
        handleCreateReport,
    };
};
